import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';
import { IUser } from 'types/chat';

export const getSuggestUser = (limit: number) => {
  limit = limit || 10;

  return Http.request<IUser[]>({
    method: 'GET',
    url: `${API_CHAT_URL}/conversation/suggest-users?limit=${limit}`,
  });
};
